<template>
  <div>
    <div class="row justify-between q-px-lg q-mx-lg q-my-md">
      <div class="row items-center">
        <div class="text-h5 text-bold text-grey-9 q-mr-lg non-selectable">
          <q-icon name="fas fa-comment-alt" class="q-mr-xs" />
          访员问题反馈处理
        </div>
        <div class="bg-grey-3 q-py-xs q-px-md rounded-borders non-selectable">
          这里汇集了访员的一些反馈信息，管理员可以依据反馈信息，联系到访员。<br />
          处理反馈后，需要您及时的修改状态。
        </div>
      </div>
      <q-btn-toggle
        v-model="filterFeedback"
        toggle-color="primary"
        no-caps
        rounded
        @input="filterAction"
        :options="[
          { label: '全部', value: 'all' },
          { label: '未处理', value: 'unreply' },
          { label: '已处理', value: 'reply' },
        ]"
      />
    </div>
    <!-- 反馈卡片 -->
    <q-scroll-area style="width: 100vw; height: calc(100% - 100px)">
      <div
        v-if="feedbackList"
        style="width: 80vw; margin: auto"
        class="q-pa-md row items-center q-gutter-md"
      >
        <q-card
          style="min-width: 300px; max-height: 420px"
          v-for="item in currentFeedbackList"
          :key="item.id"
          :class="item.reply ? 'bg-green-1' : 'bg-white'"
        >
          <q-card-section>
            <div class="text-h6">访员：{{ item.user.nickname }}</div>
            <div class="text-subtitle2">
              联系方式：{{ item.user.phone_number }}
            </div>
          </q-card-section>
          <q-separator inset />
          <q-card-section>
            <div class="text-grey-6">访员反馈信息如下：<br /></div>
            <q-scroll-area style="width: 100%; height: 200px" class="q-pt-sm">
              {{ item.content }}
            </q-scroll-area>
          </q-card-section>
          <q-separator inset />
          <q-card-actions class="q-pa-md" align="right">
            <q-btn
              flat
              color="primary"
              :disable="item.reply"
              @click="updateFeedbackState(item.id)"
            >
              <!-- <q-icon name="fas fa-check" size="1rem" class="q-mr-sm"></q-icon> -->
              <span>{{ item.reply ? "已处理" : "标记为已处理反馈" }}</span>
            </q-btn>
          </q-card-actions>
        </q-card>
        <!-- {{ feedbackList }} -->
      </div>
       <Empty class="q-mt-xl" v-if="!feedbackList || feedbackList.length === 0" />
    </q-scroll-area>
  </div>
</template>

<script>
import { getAllFeedbackList } from "@/api/endpoints/feedback/getAllFeedbackList";
import { updateFeedbackReplyState } from "@/api/endpoints/feedback/updateFeedbackReplyState";
export default {
  components: {
    Empty: () => import("@/components/Empty"),
  },
  data() {
    return {
      feedbackList: [],
      filterFeedback: "all",
      currentFeedbackList: [],
    };
  },
  mounted() {
    this.getAllFeedbackList();
  },
  watch: {
    feedbackList: {
      immediate: true,
      handler(){
        this.filterAction()
      }
    }
  },
  methods: {
    async getAllFeedbackList() {
      try {
        const res = await getAllFeedbackList();
        console.log(res);
        this.feedbackList = res;
        this.currentFeedbackList = res;
      } catch (error) {
        console.log(error);
        this.$q.notify({
          type: "danger",
          message: "出现错误" + error,
        });
      }
    },

    async updateFeedbackState(feedbackId) {
      try {
        await updateFeedbackReplyState({ reply: true }, feedbackId);
        await this.getAllFeedbackList();
      } catch (error) {
        console.log(error);
        this.$q.notify({
          type: "danger",
          message: "出现错误" + error,
        });
      }
    },

    filterAction() {
      this.currentFeedbackList = this.feedbackList.filter((item) => {
        switch (this.filterFeedback) {
          case "all":
            return item.id;
          case "unreply":
            return !item.reply;
          case "reply":
            return item.reply;
        }
      });
    },
  },
};
</script>

<style>
</style>